import { render, staticRenderFns } from "./RecordCreator.vue?vue&type=template&id=164badf7&"
import script from "./RecordCreator.vue?vue&type=script&lang=js&"
export * from "./RecordCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports